import { ClassNameBuilder, IClassNameBuilder } from '../builders/class-name-builder';
import { IServiceFactory } from '../types/service-factory';

export class ClassNameBuilderFactory implements IServiceFactory<IClassNameBuilder> {
	public Create(): IClassNameBuilder {
		return new ClassNameBuilder();
	}
}
